"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { env } from "env"
import TC_Wrapper from "react-tag-commander"

interface AnalyticsPageDisplayProps {
  pageType?: string
  pageTag?: string
  chapters?: string[]
  iseKeyword?: string
  isePage?: number
  iseEngine?: string
}

const AnalyticsPageDisplay = ({
  chapters = [],
  pageType,
  pageTag,
  iseEngine,
  isePage,
  iseKeyword,
}: AnalyticsPageDisplayProps) => {
  const pathname = usePathname()
  const wrapper = TC_Wrapper.getInstance()

  useEffect(() => {
    Promise.all([
      wrapper.addContainer(
        "container_body",
        env.NEXT_PUBLIC_TAGCO_ANALYTICS_URL,
        "body"
      ),
    ]).then(() => {
      wrapper.setTcVar(
        "page",
        chapters[chapters.length - 1] ? chapters[chapters.length - 1] : ""
      )
      wrapper.setTcVar("page_type", pageType ? pageType : "")
      wrapper.setTcVar("page_tag", pageTag ? pageTag : "")
      wrapper.setTcVar("ise_engine", iseEngine ? iseEngine : "")
      wrapper.setTcVar("ise_page", isePage ? isePage : "")
      wrapper.setTcVar("ise_keyword", iseKeyword ? iseKeyword : "")

      for (let i = 0; i < 3; i++) {
        wrapper.setTcVar(`page_chapter${i + 1}`, chapters[i] ? chapters[i] : "")
      }
    })
  }, [
    chapters,
    pathname,
    pageType,
    pageTag,
    wrapper,
    iseEngine,
    isePage,
    iseKeyword,
  ])

  return <></>
}
AnalyticsPageDisplay.displayName = "AnalyticsPageDisplay"

export { AnalyticsPageDisplay, type AnalyticsPageDisplayProps }
